import $ from 'jquery';
import { siteModel } from 'models/SiteModel';
import ArticlesNotificationContainerView from 'ui/login-bar/articles/container-view';
import SystemNotificationContainerView from 'ui/login-bar/system/container-view';
import controller from 'ui/login-bar/controller';
import articlesNotificationModel from 'models/ArticlesNotificationModel';
import systemNotificationModel from 'models/SystemNotificationModel';

const elements = {
  form: '.navbarTop-form',
  notificationContainer: ".user-toolkit",
  avatar: ".c-header-menu_handy-user_image img",
};

export default {
  init() {

    $(document).ready(() => {

      document.addEventListener('AvatarChanged', (event) => {
        $(elements.avatar).attr('src', event.detail.url);
      });

      $(document).on('keyup', '#input-remember-me', function(e) {
        if (e.keyCode === 32) {
            $(this).parent().find('label').trigger('click');
        }
      });

      if (siteModel.isUserLogged()) {
        const articleContainerView = new ArticlesNotificationContainerView(articlesNotificationModel);
        const systemContainerView = new SystemNotificationContainerView(systemNotificationModel);

        controller.initCheckStatus();

        articleContainerView.render();
        systemContainerView.render();

        $(document).on('click', (event) => {
            event.stopPropagation();
              const container = $(elements.notificationContainer);
              const targetIsBubbleBox = !!container.is(event.target);
              const targetIsBubbleBoxChild = !!$(event.target)
                .parents(elements.notificationContainer).length;

              if (!targetIsBubbleBox && !targetIsBubbleBoxChild && !controller.intervalId) {
                return controller.initCheckStatus();
              }
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/index.js